'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    {filter, some, map} = require('lodash/collection'),
    get = require('lodash/object').get,
    Constants = require('constants/AppConstants'),
    SessionStore = require('stores/SessionStore'),
    InventoryStore = require('stores/InventoryStore'),
    NumberUtils = require('utils/NumberUtils'),
    ContentUtils = require('utils/ContentUtils'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    NavigationUtils = require('utils/NavigationUtils'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    ga = require('react-ga'),
    {Navigation} = require('react-router'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const AMOUNT_DECIMAL = 4;

let ProductItemAdmin = React.createClass({displayName: "ProductItemAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            product: NavigationUtils.getPathParam('products'),
            productName: NavigationUtils.getQueryParam('productName'),
            beerStyleName: NavigationUtils.getQueryParam('beerStyle'),
            volume: NavigationUtils.getQueryParam('volume'),
            unit: NavigationUtils.getQueryParam('unit'),
            isEditMode: false
        };
    },

    _hydrateProductItems(productItems) {
        return map(productItems, productItem => {
            productItem.amountWithUnit =
                NumberUtils.formatDecimal(get(productItem, 'defaultAmount')) +
                ' ' +
                get(productItem, 'item.unit', '');
            return productItem;
        });
    },

    componentDidMount() {
        this.fetchItems();
        ga.pageview('/product-items');
    },

    _backToProducts() {
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
        this.transitionTo(
            `/products`,
            {},
            {
                productSelectedId
            }
        );
    },

    _goToIcons() {
        const productIdSelected = NavigationUtils.getPathParam('products');
        const productName = NavigationUtils.getQueryParam('productName');
        const beerStyle = NavigationUtils.getQueryParam('beerStyle');
        const volume = NavigationUtils.getQueryParam('volume');
        const unit = NavigationUtils.getQueryParam('unit');
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');

        this.transitionTo(`/products/${productIdSelected}/items`);

        this.transitionTo(
            `/products/:productId/:page`,
            {
                productId: productIdSelected,
                page: 'icons'
            },
            {
                productSelectedId,
                productName,
                beerStyle,
                volume,
                unit
            }
        );
    },

    fetchItems() {
        const self = this;
        const currentProductId = NavigationUtils.getPathParam('products');

        InventoryStore.fetchAllItems(function (items) {
            InventoryStore.fetchItemsSubtraction(currentProductId, function (productItems) {
                const productItemsHydrated = self._hydrateProductItems(productItems);
                const itemsSorted = ContentUtils.sortList(items, 'description');

                self.setState({
                    productItems: ContentUtils.filterEnable(productItemsHydrated),
                    items: ContentUtils.filterNonInventoryItems(ContentUtils.filterEnable(itemsSorted))
                });
            });
        });
    },

    _onRowSelection(productItem,
                    itemIndex,
                    lastRowScrollPosition,
                    headerActiveFilters) {
        if (productItem && productItem.item) {
            productItem.name = get(productItem, 'item.description');
        }

        this.setState(
            {
                selectProductItem: productItem,
                isEditMode: !!productItem,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onDeleteItem(id, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('product_substraction_warning_remove_item_future'),
            () => {
                InventoryStore.deleteProductItem(id, onSuccess, onFailure);
            }
        );
        this._clean();
    },

    _onChangeItem(productItem, onSuccess, onFailure) {
        const productId = NavigationUtils.getPathParam('products');
        productItem.isAddition = false;
        InventoryStore.changeProductItem(
            productId,
            productItem,
            onSuccess,
            onFailure
        );
        this._clean();
    },

    _onAddItem(productItem, onSuccess, onFailure) {
        const productId = NavigationUtils.getPathParam('products');
        productItem.isAddition = false;
        InventoryStore.addProductItem(
            productId,
            productItem,
            onSuccess,
            onFailure
        );
        this._clean();
    },

    _onCancel() {
        this._clean();
    },

    _clean() {
        this.setState({
            selectProductItem: null,
            selectProductItemDropDown: null,
            preSelectedItem: null
        });
    },


    _onBlurSelectedItem(preSelectedItem) {
        if (preSelectedItem) {
            this.setState(prevState => {
                if (prevState.selectedItem) {
                    return {
                        preSelectedItem: Object.assign(
                            prevState.selectedItem,
                            preSelectedItem
                        )
                    };
                } else {
                    return {
                        preSelectedItem
                    };
                }
            });
        }
    },

    _getBreadcrumbLinks() {
        const {productName, beerStyleName} = this.state;
        const volumeWithUnit = this._getVolumeWithUnit();
        return [
            {
                displayName: t('dashboard_sidebar_products'),
                link: 'products'
            },
            {
                displayName: `${productName} (${beerStyleName} ${volumeWithUnit})`
            }
        ];
    },

    _getVolumeWithUnit() {
        const {volume, unit} = this.state;
        const volumeFormatted = NumberUtils.formatDecimal(volume);
        return `${volumeFormatted}${unit}`;
    },

    _isValidProductItems(selectedItemId) {
        const currentItemId = get(selectedItemId, 'item.id');
        const {selectProductItem} = this.state;
        const isNewProductItem = ContentUtils.isNull(selectProductItem);
        let productItemsId;

        // only in the new operation
        if (isNewProductItem) {
            productItemsId = map(this.state.productItems, productItem => get(productItem, 'item.id')) || [];
        } else {
            const previousSelectedItemId = get(this.state, 'item.id') || currentItemId;
            productItemsId = filter(map(this.state.productItems, productItem => get(productItem, 'item.id')), itemId => itemId !== previousSelectedItemId) || [];
        }

        const isAlreadyExist = productItemsId.includes(currentItemId);
        if (isAlreadyExist) {
            return t('product_substraction_warning_item_duplicated');
        }
        return ''; // empty is valid
    },

    _onChangeDropDownItem(selectedItem) {
        this.setState({
            selectProductItemDropDown: selectedItem
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _goToProductItemsAddition() {
        const productIdSelected = NavigationUtils.getPathParam('products');
        const productName = NavigationUtils.getQueryParam('productName');
        const beerStyle = NavigationUtils.getQueryParam('beerStyle');
        const volume = NavigationUtils.getQueryParam('volume');
        const unit = NavigationUtils.getQueryParam('unit');
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');

        this.transitionTo(`/products/${productIdSelected}/items`);

        this.transitionTo(
            `/products/:productId/items-addition`,
            {
                productId: productIdSelected
            },
            {
                productSelectedId,
                productName,
                beerStyle,
                volume,
                unit
            }
        );
    },

    render() {
        let contextHolder = this.getContextHolderInstance();
        const messages = {
            changeSuccessMessage: t('product_substraction_change_success'),
            changeFailureMessage: t('product_substraction_change_failure'),
            deleteSuccessMessage: t('product_substraction_delete_success'),
            addSuccessMessage: t('product_substraction_add_success'),
            addFailureMessage: t('product_substraction_add_failure')
        };
        let {
            selectProductItem,
            typeTank,
            currentBeerStyle,
            productItems,
            items,
            isEditMode,
            selectProductItemDropDown,
            preSelectedItem
        } = this.state;

        let itemUnit;

        if (selectProductItem) {
            itemUnit = get(selectProductItem, 'item.unit');
        } else {
            itemUnit = get(preSelectedItem, 'unit');
        }

        const itemUnitWithParenthesis = itemUnit ? '(' + itemUnit + ')' : 'unit';
        const currentItemSelected = get(selectProductItemDropDown, 'item') || get(selectProductItem, 'item');
        const volumeWithUnit = this._getVolumeWithUnit();

        const additionalButtons = [
            {
                type: 'CHANGE',
                permission: 'SHOW',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick: this._backToProducts}
                    )
                )
            },
            {
                type: 'NEW',
                permission: 'SHOW',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick: this._backToProducts}
                    )
                )
            },
            {
                permission: 'SHOW',
                type: 'NEW',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('product_addition_set_icons'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick: this._goToIcons}
                    )
                )
            },
            {
                type: 'CHANGE',
                permission: 'SHOW',
                el: React.createElement(FormGroupButton, {
                    label: t('product_admin_set_addition_icons'), 
                    icon: "subdirectory_arrow_right", 
                    type: "icon", 
                    onClick:  this._goToProductItemsAddition}
                )
            },
            {
                type: 'NEW',
                permission: 'SHOW',
                el: React.createElement(FormGroupButton, {
                    label: t('product_admin_set_addition_icons'), 
                    icon: "subdirectory_arrow_right", 
                    type: "icon", 
                    onClick:  this._goToProductItemsAddition}
                )
            }
        ];

        const formFieldsEl = [
            React.createElement(FormGroupTextFieldSuggested, {
                operationsHolder: contextHolder, 
                items: items, 
                itemsDisabled: filterItemsAlreadyInUse(items, productItems), 
                readerAttribute: "description", 
                readerAttributeValue: "id", 
                writerAttribute: "item.id", 
                name: t('item'), 
                additionalValidation:  this._isValidProductItems.bind(this), 
                value: currentItemSelected || preSelectedItem, 
                onChange: this._onChangeDropDownItem, 
                onEnter: this._onEnterPress, 
                onBlur: this._onBlurSelectedItem, 
                isImmutable: true}
            ),

            React.createElement(FormGroupTextfield, {
                operationsHolder: contextHolder, 
                readerAttribute: "defaultAmount", 
                additionalValidation: inputValue =>
                    NumberUtils.isNumber(inputValue) &&
                    NumberUtils.getNumber(inputValue) > 0
                        ? ''
                        : t('product_items_subtraction_admin_message_amount_number'), 
                name: t('label_amount'), 
                value: selectProductItem, 
                label: `${t('label_amount')} ${itemUnitWithParenthesis} ${t('per')} (${volumeWithUnit})`, 
                isRelaxedText: true, 
                isDecimalFormat: true, 
                decimalDigits: AMOUNT_DECIMAL, 
                isEditMode: isEditMode, 
                onEnter: this._onEnterPress}
            )
        ];
        return (
            React.createElement(AdminScaffolding, {
                moduleName: "ADMIN_PRODUCT_ITEMS_SUBSTRACTION", 
                messages: messages, 
                additionalSubmitValue: {
                    styleBeerId: currentBeerStyle,
                    typeTank: typeTank
                }, 
                additionalButtons: additionalButtons, 
                title: t('product_items_subtraction_admin_title_subtraction_items'), 
                onAddText: t('product_addition_add'), 
                contextHolder: contextHolder, 
                value: selectProductItem, 
                fetchItems: this.fetchItems, 
                headerFields: formFieldsEl, 
                addEnterKeyDown: this._addEnterKeyDown, 
                onAdd: this._onAddItem, 
                onChange: this._onChangeItem, 
                onCancel: this._onCancel, 
                onDelete: this._onDeleteItem, 
                breadcrumb: this._getBreadcrumbLinks(), 
                shouldFocusDidMount: true
            }, 

                React.createElement(AdminScaffoldingTable, {
                    headerActiveFilters: this.state.headerActiveFilters, 
                    sortByColumn: ['item.description'], 
                    onRowSelection: this._onRowSelection, 
                    value: selectProductItem, 
                    columnNames: [
                      t('product_addition_column_description'),
                      t('product_addition_column_amount'),
                      t('product_addition_column_unit')
                    ], 
                    filteredColumns: ['item.description', 'amountWithUnit'], 
                    nameFieldIdentifier: "item.id", 
                    displayAttributes: ['item.description', 'amountWithUnit']
                }, 
                    productItems
                )
            )
        );
    }
});

function filterItemsAlreadyInUse(items, productItems) {
    const itemIdsAlreadyInUse = map(productItems, productItem => get(productItem, 'item.id')) || [];
    const itemsFiltered = filter(items, item => itemIdsAlreadyInUse.includes(get(item, 'id')));
    const itemsMarked = map(itemsFiltered, item => {
       item.isDisabled = true;
       return item;
    });

    return itemsMarked;
}

module.exports = ProductItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ProductsAdmin/ProductItemsSubtractionAdmin.jsx
 **/